module Bookhus.SearchWidget {

    export interface IGeoLocationWidgetOptions {
        customClass: string;
        treeData: string; // Tree structure data in string format
    }

    interface TreeNode {
        name: string;
        state: 'none' | 'semi' | 'checked';
        id: string;
        children?: TreeNode[];
    }

    export class GeoLocationWidget {

        private container: JQuery;
        private options: IGeoLocationWidgetOptions;

        constructor(selector: string, options: Partial<IGeoLocationWidgetOptions>) {

            if (selector == "" || !selector) {
                console.log("Selector missing");
                return;
            }

            this.setOptions(options);

            this.container = $(selector);
            this.injectCSS('/Content/bookhus/geo-location_widget/index.css');
            this.buildContainer();
        }

        private setOptions(options: Partial<IGeoLocationWidgetOptions>) {
            this.options = $.extend(true, {
                customClass: '',
                treeData: '' // Default tree data
            } as IGeoLocationWidgetOptions, options);
        }

        private injectCSS(href: string): void {
            if (!$(`link[href="${href}"]`).length) {
                const link = document.createElement('link');
                link.rel = 'stylesheet';
                link.type = 'text/css';
                link.href = href;
                document.getElementsByTagName('head')[0].appendChild(link);
            }
        }

        private getSearchWidgetLanguage(): any {
            var bookhus = (window as any).Bookhus;
            if (bookhus
                && bookhus.Localization
                && bookhus.Localization.Standard
                && bookhus.Localization.Standard.UI
                && bookhus.Localization.Standard.UI.Widgets) {
                return bookhus.Localization.Standard.UI.Widgets.SearchWidget;
            }
            return null;
        }

        private translate(name: string): string {
            var searchWidgetLanguage = this.getSearchWidgetLanguage();
            if (!searchWidgetLanguage) {
                return "";
            }

            return searchWidgetLanguage[name] || "";
        }

        private buildContainer(): void {
            this.container.addClass(`${this.options.customClass}`);

            this.container.html(`
                <div class="custom-dropdown">
                    <div class="custom-dropdown-toggle form-control" id="geoLocationDropdownToggle">${this.translate("ChooseALocation")}</div>
                    <div class="custom-dropdown-menu" id="geoLocationDropdownMenu">
                        <ul class="tree-container"></ul>
                    </div>
                </div>
            `);

            const treeData = this.parseTreeData(this.options.treeData);
            this.buildTree(treeData, this.container.find('#geoLocationDropdownMenu > ul'));
            this.initEvents();
            this.updateTitle();
        }

        private parseTreeData(data: string): TreeNode {
            const parseNode = (nodeStr: string): TreeNode => {
                const [nameState, childrenStr] = nodeStr.match(/^([^{}]+)(\{.*\})?$/)!.slice(1);
                const [nameStateId, id] = nameState.split(';');
                var [name, state] = nameState.split(':');
                if (state.indexOf(";") >= 0) {
                    state = state.split(';')[0];
                }
                const node: TreeNode = { name, state: state as 'none' | 'semi' | 'checked', id: id || ''};

                if (childrenStr) {
                    const childrenData = childrenStr.slice(1, -1);
                    node.children = parseChildren(childrenData);
                }

                return node;
            };

            const parseChildren = (data: string): TreeNode[] => {
                const nodes: TreeNode[] = [];
                let stack: string[] = [];
                let current = '';

                for (const char of data) {
                    if (char === '{') {
                        stack.push(current);
                        current = '';
                    } else if (char === '}') {
                        const parent = stack.pop();
                        if (parent !== undefined) {
                            current = `${parent}{${current}}`;
                        }
                    } else if (char === ',' && stack.length === 0) {
                        nodes.push(parseNode(current));
                        current = '';
                    } else {
                        current += char;
                    }
                }
                if (current) {
                    nodes.push(parseNode(current));
                }
                return nodes;
            };

            return parseNode(data);
        }

        private buildTree(node: TreeNode, $parent: JQuery): void {
            if (node.state === 'none') {
                if (node.children) {
                    node.children.forEach(childNode => this.buildTree(childNode, $parent));
                }
                return;
            }

            const $nodeElement = $(`
                <li>
                    <label>
                        <input type="checkbox" value="${node.id}" name="GeoLokation" class="tree-checkbox" data-name="${node.name}">
                        ${node.name}
                    </label>
                </li>
            `);

            $parent.append($nodeElement);

            if (node.children && node.children.length > 0) {
                const $childrenContainer = $('<ul></ul>');
                $nodeElement.append($childrenContainer);
                node.children.forEach(childNode => this.buildTree(childNode, $childrenContainer));
            }
        }

        private initEvents(): void {
            const toggle = this.container.find('#geoLocationDropdownToggle');
            const menu = this.container.find('#geoLocationDropdownMenu');

            toggle.on('click', () => {
                menu.toggle();
            });

            $(document).on('click', (event) => {
                if (!this.container.is(event.target as any) && this.container.has(event.target as any).length === 0) {
                    menu.hide();
                }
            });

            this.container.on('click', '.tree-checkbox', (event) => {
                const $checkbox = $(event.target);
                const isChecked = $checkbox.is(':checked');

                this.updateChildren($checkbox, isChecked);
                this.updateParent($checkbox);

                this.updateTitle()
            });
        }

        private updateTitle(): void {
            //ChoosenLocations ChoosenMultipleLocations

            var _selectedItems = $("#geoLocationDropdownMenu input:checked");
            if (_selectedItems.length > 0) {
                var _text = this.FormatString(this.translate("ChoosenLocations"), _selectedItems.first().parent().text())
                if (_selectedItems.length > 1) {
                    _text = this.FormatString(this.translate("ChoosenMultipleLocations"), _selectedItems.first().parent().text(), ""+(_selectedItems.length - 1))
                }
                $("#geoLocationDropdownToggle").text(`${_text}`)
            } else {
                $("#geoLocationDropdownToggle").text(`${this.translate("ChooseALocation")}`)
            }
        }

        private updateChildren($checkbox: JQuery, isChecked: boolean) {
            const $childrenContainer = $checkbox.closest('li').find('> ul');
            if ($childrenContainer.length > 0) {
                $childrenContainer.find('input.tree-checkbox').each((index, childCheckbox) => {
                    $(childCheckbox).prop('checked', isChecked).prop('indeterminate', false);
                    this.updateChildren($(childCheckbox), isChecked);
                });
            }
        }

        private FormatString(str: string, ...val: string[]) {
            for (let index = 0; index < val.length; index++) {
                str = str.replace(`{${index}}`, val[index]);
            }
            return str;
        }

        private updateParent($checkbox: JQuery) {
            const $parentCheckbox = $checkbox.closest('ul').closest('li').find('> label > input.tree-checkbox');
            if ($parentCheckbox.length > 0) {
                const $siblings = $checkbox.closest('ul').find('> li > label > input.tree-checkbox');
                const allChecked = $siblings.length === $siblings.filter(':checked').length;
                const anyChecked = $siblings.closest("li").find(':checkbox').filter(":checked").length;
                const isIndeterminate = anyChecked && !allChecked;

                $parentCheckbox.prop('checked', allChecked).prop('indeterminate', isIndeterminate);

                this.updateParent($parentCheckbox);
            }
        }

        public init() {
        }
    }
}
